import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IVeiculoProprietario } from "../../../../interface/VeiculoProprietario";

export const VeiculoProprietarioPage = (
  data: IVeiculoProprietario
) => {
  return (
    <Panel header="Automotiva Proprietário Veicular">
      {data?.dados?.registro?.length > 0 ? (
        <DataTable
          value={data.dados.registro}
          className="p-datatable-sm"
        >
          <Column header="Placa" field="Placa" />
          <Column header="Renavam" field="Renavam" />
          <Column header="Chassi" field="Chassi" />
          <Column header="Marca" field="MarcaModelo" />
          <Column header="Cor" field="Cor" />
          <Column header="Tipo" field="TipoVeiculo" />
          <Column header="Capacidade" field="Cap_Passageiros" />
          <Column header="Ano Modelo" field="AnoModelo" />
          <Column header="Ano Fabricação" field="AnoFabricacao" />
          <Column header="Motor" field="Motor" />
          <Column header="Município" field="Municipio" />
          <Column header="UF" field="Uf" />
          <Column header="Combustível" field="Combustivel" />
          <Column header="Potência" field="Potencia" />
          <Column header="Espécie" field="Especie" />
        </DataTable>
      ) : (
        <p
          style={{
            textAlign: "center",
            padding: "10px",
            fontStyle: "italic",
            color: "#666",
          }}
        >
          {data?.MENSAGEM || "Não há registros na base consultada."}
        </p>
      )}
    </Panel>
  );
};
